export default __webpack_public_path__ + "static/media/claimsArrow.b8901ae3.svg";